module.exports = __webpack_public_path__ + "fonts/2F59F3_2_0.3bf4181.woff";